import { jsx as _jsx } from "react/jsx-runtime";
const Layout = (props) => (_jsx("div", Object.assign({ className: "layout-container" }, { children: _jsx("div", Object.assign({ className: "content" }, { children: props.children })) })));
export default Layout;
